/**
 *
 * ShipmentLaneComponent
 *
 */

import React, { Fragment } from "react";
import PropTypes from "prop-types";
import scrollToComponent from "react-scroll-to-component";
import {
  cookieBridge,
  validations,
  dates,
  removeIndexSuffix,
  IntlPropType,
  trackEngagementInteraction,
  trackContentInteraction,
} from "root/libs/core-libs/src";
import {
  abTestVersions,
  STEPPER,
} from "root/libs/ui-containers/src/lib/AbTest";
import { DhlCheckbox, DhlText } from "@dhl-official/react-library";
import { Sizes } from "@dhl-official/stencil-library";
import isNil from "lodash/isNil";
import ResponsiveRender from "one-time-shipment/src/components/Layout/ResponsiveRender";
import {
  SEGMENT_TYPES,
  SHIPMENT_TYPES,
  CATEGORIES,
} from "one-time-shipment/src/containers/SpotShipmentPage/constants";
import {
  ErrorBoundary,
  IconButtonTooltip,
  Icon,
} from "root/libs/ui-components/src";
// Loadable loads the components async
import DimensionSelector from "one-time-shipment/src/components/FreightItem/DimensionSelector";
import plusIcon from "icons/cx/plus.svg";
import closeIcon from "icons/cx/close.svg";
import { injectIntl } from "react-intl";
import { CountrySettings } from "root/libs/ui-containers/src";
import { selectTrackingKey } from "one-time-shipment/src/containers/Tracking/selectors";
import {
  SS,
  COMMON,
  UTF_EVENT_PAGE_NAMES,
  UTF_EVENT_CONTENT_NAMES,
  UTF_EVENT_TYPES,
  UTF_EVENT_INTERACTIONS,
  UTF_EVENT_CONTENT_POSITION,
} from "root/libs/constants/src";
import arrowBack from "@dhl-official/icons/arrow-back.svg";
import { isScrollEnabled } from "one-time-shipment/src/helpers/isScrollDisabled";
import UnitSelectorContainer from "one-time-shipment/src/components/FreightItem/UnitSelector/container";
import {
  ShipmentLaneFormWrapper,
  ItemCardWrapper,
  ItemCardContent,
  SubmitButton,
  SettingsCheckboxWrapper,
  StyledCheckboxInfo,
  StyledWeightSelector,
  ShipmentItemContainer,
  ShipmentItemContainerGroup,
  BackButtonCell,
  StepNoteCell,
  StyledIconButton,
  StyledItemIndexNumber,
  StyledCloseIcon,
  StyledHiddenCloseIconContainer,
  StyledHiddenCloseIcon,
  StyledTotalShipmentWeightWrapper,
  ToolTipText,
  StyledIconWrapper,
  CustomBackButton,
  ShipmentLaneAdvancedSettings,
  StyledItemCardHeader,
  StyledItemParameters,
} from "./styled";
import { PackageTypeSelector } from "../PackageTypeSelector";
import { PackageCategorySelector } from "../PackageCategorySelector";
import { PackageItemList } from "../PackageItemList";
import { PackagePreserSelector } from "../PackagePresetSelector";

const { withCountry } = CountrySettings;

const COPY_ID_PREFIX = "ShipmentLaneComponent";

const COPY_ID_PREFIX_NAVIGATION = "NavigationButton";

const COPY_ID_PREFIX_STEPPER = "Stepper";

class FreightComponent extends React.PureComponent {
  static propTypes = {
    /** Translations library  */
    intl: IntlPropType.isRequired,
    waitingForResponse: PropTypes.bool,
    items: PropTypes.array.isRequired,
    getOffers: PropTypes.func.isRequired,
    updateItem: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    clearDimensionFieldsValidationErrors: PropTypes.func.isRequired,
    /** Function to be called to check if the entered value is valid. Receives a valid DOM input element */
    validateFormFields: PropTypes.func.isRequired,
    isShipmentLaneVisibile: PropTypes.bool.isRequired,
    trackEvent: PropTypes.func,
    shouldScroll: PropTypes.bool,
    resetScrolling: PropTypes.func,
    validity: PropTypes.object.isRequired,
    isFormValid: PropTypes.bool.isRequired,
    offersLaneReference: PropTypes.object,
    prefillItemsValues: PropTypes.array,
    /** If set to true, AdvancedSettings and business presets will be shown */
    isBusiness: PropTypes.bool,
    documentsOptionValue: PropTypes.object,
    updateDocument: PropTypes.func.isRequired,
    settingsDangerousGoods: PropTypes.bool,
    backToShipmentLaneReference: PropTypes.object,
    backToTradeLaneReference: PropTypes.object,
    segmentReference: PropTypes.object,
    onCheckboxChange: PropTypes.func,
    onMoveToOffersClick: PropTypes.func,
    hasBackButtonClicked: PropTypes.func,
    settingsNonStackable: PropTypes.bool,
    configs: PropTypes.shape({
      isDangerousGoodsEnabled: PropTypes.bool,
      isQuantitySelectorEnabled: PropTypes.bool,
      isAddItemEnabled: PropTypes.bool,
      maxNumberOfShipmentItems: PropTypes.number,
    }).isRequired,
    addShipmentLaneItem: PropTypes.func,
    spotShipmentPresetSizes: PropTypes.shape({
      weightBreakThreshold: PropTypes.object,
      private: PropTypes.arrayOf(
        PropTypes.shape({
          key: PropTypes.string,
          value: PropTypes.string,
          label: PropTypes.string,
          icon: PropTypes.string,
          values: PropTypes.shape({
            length: PropTypes.string,
            width: PropTypes.string,
            height: PropTypes.string,
            presetSize: PropTypes.string,
          }),
        })
      ),
      business: PropTypes.arrayOf(
        PropTypes.shape({
          key: PropTypes.string,
          value: PropTypes.string,
          label: PropTypes.string,
          icon: PropTypes.string,
          values: PropTypes.shape({
            length: PropTypes.string,
            width: PropTypes.string,
            height: PropTypes.string,
            presetSize: PropTypes.string,
          }),
        })
      ),
    }).isRequired,
    removeShipmentLaneItem: PropTypes.func.isRequired,
    /* Define the preset collection that is shown in Business funnel when weight is still empty */
    /* Contains the total weight of all items of the shipment */
    totalShipmentWeight: PropTypes.number.isRequired,
    unitSystem: PropTypes.object.isRequired,
    selectedUnitSystem: PropTypes.string.isRequired,
    isUnitSwitchEnabled: PropTypes.bool,
    /* Holds the threshold weight value to compare the current total
     * weight against, that will enable several checkboxes in the Shipment Lane
     */
    shipmentLaneCheckboxStatusWeightThreshold: PropTypes.object.isRequired,
    pageName: PropTypes.string.isRequired,
    experience: PropTypes.string,
    abTestRunning: PropTypes.bool,
    abTestVersion: PropTypes.string,
    selectedCategory: PropTypes.string,
    changeCategory: PropTypes.func.isRequired,
    resetItems: PropTypes.func.isRequired,
  };

  static defaultProps = {
    waitingForResponse: false,
    trackEvent: () => {},
    shouldScroll: false,
    resetScrolling: () => {},
    offersLaneReference: {},
    prefillItemsValues: [],
    isBusiness: false,
    settingsDangerousGoods: false,
    backToShipmentLaneReference: React.createRef(),
    backToTradeLaneReference: React.createRef(),
    segmentReference: React.createRef(),
    onCheckboxChange: () => {},
    settingsNonStackable: false,
    addShipmentLaneItem: () => {},
    isUnitSwitchEnabled: false,
    experience: "",
    abTestRunning: false,
  };

  constructor(props) {
    super(props);
    this.formReference = React.createRef();
    this.headlineReference = React.createRef();
    this.shipmentLaneItemReferences = [React.createRef()];
    this.shipmentLaneFirstInputReferences = [React.createRef()];
    this.dimensionSelectorWithCountry = withCountry(DimensionSelector);
    this.weightSelectorWithCountry = withCountry(StyledWeightSelector);
    this.shipmentPresetSelectorWithCountry = withCountry(PackagePreserSelector);
    this.experience = props.experience;

    const trackingKeySelector = selectTrackingKey;

    this.getOffersTrackingKeyPath = trackingKeySelector(
      "spotShipment.interactions.offersTriggers.getOffersClicked"
    );
    this.documentsCheckboxTrackingKeyPath = trackingKeySelector(
      "spotShipment.interactions.offersTriggers.documentsCheckboxChecked"
    );
    this.documentsCheckboxIconTrackingKeyPath = trackingKeySelector(
      "spotShipment.interactions.clickedOnDocumentsCheckboxIcon"
    );
    this.dangerousGoodsCheckboxTrackingKeyPath = trackingKeySelector(
      "spotShipment.initialSet.settingsDangerousGoods"
    );
    this.dangerousGoodsCheckboxIconTrackingKeyPath = trackingKeySelector(
      "spotShipment.interactions.clickedOnDangerousGoodsCheckboxIcon"
    );
    this.documentsCheckboxIconTrackEventKey = "clickedOnDocumentsCheckboxIcon";
    this.dangerousGoodsCheckboxIconTrackEventKey =
      "clickedOnDangerousGoodsCheckboxIcon";

    this.addShipmentLaneItemClickedTrackingKeyPath = trackingKeySelector(
      "spotShipment.interactions.clickedOnAddShipmentLaneItem"
    );
    this.removeShipmentLaneItemClickedTrackingKeyPath = trackingKeySelector(
      "spotShipment.interactions.clickedOnRemoveShipmentLaneItem"
    );
    this.addShipmentLaneItemClickedTrackEventKey =
      "clickedOnAddShipmentLaneItem";
    this.removeShipmentLaneItemClickedTrackEventKey =
      "clickedOnRemoveShipmentLaneItem";

    let documentCheckboxState = null;
    const { isBusiness, documentsOptionValue } = this.props;
    if (!isNil(documentsOptionValue)) {
      const checkboxState = isBusiness
        ? documentsOptionValue[SEGMENT_TYPES.business]
        : documentsOptionValue[SEGMENT_TYPES.private];
      if (checkboxState)
        documentCheckboxState = checkboxState
          ? SHIPMENT_TYPES.Documents
          : SHIPMENT_TYPES.NonDocuments;
    }

    this.state = {
      isItemRemoved: false,
      // documentsCheckboxDisabled: false,
      dangerousGoodsCheckboxDisabled: false,
      shipmentType: documentCheckboxState,
    };
  }

  componentDidMount = () => {
    document.addEventListener("animationend", this.handleAnimationEnd);
  };

  componentDidUpdate = (prevProps) => {
    const {
      shouldScroll,
      resetScrolling,
      isShipmentLaneVisibile,
      trackEvent,
      isBusiness,
      pageName,
    } = this.props;

    const { SHIPMENT_LANE } = UTF_EVENT_PAGE_NAMES;

    if (
      isShipmentLaneVisibile !== prevProps.isShipmentLaneVisibile &&
      isShipmentLaneVisibile
    ) {
      trackEvent({ shipmentLaneRendered: true });

      trackEngagementInteraction({
        funnel: {
          name: pageName,
          type: UTF_EVENT_CONTENT_NAMES.CUSTOMER_JOURNEY,
          step: SHIPMENT_LANE,
          progress: UTF_EVENT_INTERACTIONS.LOAD,
        },
        content: {
          context: isBusiness ? SEGMENT_TYPES.business : SEGMENT_TYPES.private,
        },
      });
    }

    if (shouldScroll && isScrollEnabled()) {
      setTimeout(() => {
        scrollToComponent(this.headlineReference.current, {
          offset: -100,
          align: "top",
        });
        resetScrolling();
      }, 0);
    }

    if (prevProps.isBusiness !== isBusiness) {
      // Those fields should reset when isBusiness change as the change is coming from previous step
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        shipmentType: null,
        dangerousGoodsCheckboxDisabled: false,
      });
    }
  };

  componentWillUnmount = () => {
    document.removeEventListener("animationend", this.handleAnimationEnd);
  };

  handleAnimationEnd = (event) => {
    const { removeShipmentLaneItem } = this.props;
    const { animationName, target } = event;
    if (animationName === "remove-item-hide") {
      const itemIndex = parseInt(target.id, 10);
      removeShipmentLaneItem(itemIndex);
      this.setState({ isItemRemoved: true });
    }
  };

  isDimensionField = (fieldName) =>
    ["length", "width", "height"].includes(fieldName);

  setTargetServiceCardCookie = () => {
    const { TARGET_SERVICE_CARD_COOKIE } = COMMON;
    const currentCookieValue =
      cookieBridge.getCookie(TARGET_SERVICE_CARD_COOKIE.name) || 0;

    if (currentCookieValue < TARGET_SERVICE_CARD_COOKIE.maxValue) {
      cookieBridge.setCookie(
        TARGET_SERVICE_CARD_COOKIE.name,
        +currentCookieValue + 1,
        TARGET_SERVICE_CARD_COOKIE.age
      );
    }
  };

  prepareUtfFormSubmitData = () => {
    const {
      items,
      settingsDangerousGoods,
      documentsOptionValue,
      isBusiness,
    } = this.props;
    const segment = isBusiness ? SEGMENT_TYPES.business : SEGMENT_TYPES.private;

    const output = {};

    items.map((d, i) =>
      Object.assign(output, {
        [`item${
          i + 1
        }`]: `weight:${d.weight}|length:${d.length}|width:${d.width}|height:${d.height}|isDocuments:${documentsOptionValue[segment]}|nonStackable:${d.settingsNonStackable}|dangerousGoods:${settingsDangerousGoods}|quantity:${d.quantity}`,
      })
    );

    return output;
  };

  onSubmit = () => {
    const {
      getOffers,
      onSubmit,
      trackEvent,
      offersLaneReference,
      waitingForResponse,
      isBusiness,
      onMoveToOffersClick,
    } = this.props;

    if (!waitingForResponse) {
      getOffers();
      onSubmit();
      onMoveToOffersClick();
      this.setTargetServiceCardCookie();
      trackEvent({ quoteEnded: dates.getNowIsoString() });
      const attributes = this.prepareUtfFormSubmitData();

      trackContentInteraction({
        name: UTF_EVENT_CONTENT_NAMES.FORM_SUBMIT,
        type: UTF_EVENT_TYPES.BUTTON,
        interaction: UTF_EVENT_INTERACTIONS.CLICK,
        position: UTF_EVENT_CONTENT_POSITION.SHIPMENT_LANE,
        context: isBusiness ? SEGMENT_TYPES.business : SEGMENT_TYPES.private,
        attributes,
      });

      if (isScrollEnabled()) {
        scrollToComponent(offersLaneReference.current, {
          offset: -90,
          align: "top",
        });
      }
    }
  };

  onWeightChange = (input, itemIndex, unitSystem) => {
    const {
      updateItem,
      // isBusiness,
      // shipmentLaneCheckboxStatusWeightThreshold,
      // selectedUnitSystem,
      // onCheckboxChange,
    } = this.props;

    const { name, value } = input;

    const newItemValues = {
      [name]: value,
      unitSystem,
    };

    updateItem({ itemIndex, newItemValues });
    // if (
    //   isBusiness &&
    //   value < shipmentLaneCheckboxStatusWeightThreshold[selectedUnitSystem]
    // ) {
    // onCheckboxChange("settingsDangerousGoods", false);
    // }
  };

  clearPresetsForAllItems = () => {
    const { updateItem, items } = this.props;
    items.forEach((item, itemIndex) => {
      if (item.preset || item.presetSize) {
        updateItem({
          itemIndex,
          newItemValues: {
            preset: "",
            presetSize: "",
          },
        });
        // Clear preset validation errors by validating with empty value
        const validationInput = {
          name: `preset-${itemIndex}`,
          value: "",
          required: true,
          validationAttributes: {
            required: true,
          },
        };
        this.validateFormFields(validationInput, itemIndex);
      }
    });
  };

  onCategoryChange = (event) => {
    const { changeCategory, resetItems } = this.props;
    resetItems();

    this.clearPresetsForAllItems();
    changeCategory(event.target.value);
  };

  disableOtherCheckbox = (name, status) => {
    // Make other checkbox disabled and unchecked
    if (name === "documents") {
      this.setState({ dangerousGoodsCheckboxDisabled: status });
    }
  };

  validateFormFields = (input) => {
    const { validateFormFields, isBusiness } = this.props;
    // We have to go two levels up to get the validationProperties
    // Since the DhlInputField render the props we need in the grandparent element
    let validationProperties = input;
    // Before this function is executed, the same in the form is executed.
    // In there, the validationAttributes are added to the input
    // here we check that we dont extract them again
    if (!input.validationAttributes) {
      validationProperties = validations.extractValidationProperties(input);
    }

    // Derive item index from input name
    validationProperties.itemIndex = (input.name || "").split("-")[1] || 0;

    validationProperties.isBusiness = isBusiness;

    validateFormFields(validationProperties);
  };

  getSegmentForPresets = (itemIndex = 0) => {
    const {
      spotShipmentPresetSizes,
      isBusiness,
      items: {
        [itemIndex]: { weight },
      },
      selectedUnitSystem,
      selectedCategory,
    } = this.props;
    if (
      selectedCategory !== CATEGORIES.Pallet &&
      (!isBusiness ||
        !spotShipmentPresetSizes.weightBreakThreshold[selectedUnitSystem] ||
        weight === "" ||
        Number(weight.replace(",", ".")) <
          spotShipmentPresetSizes.weightBreakThreshold[selectedUnitSystem])
    ) {
      return SEGMENT_TYPES.private;
    }

    return SEGMENT_TYPES.business;
  };

  shouldPresetGetDeselected = (input) => {
    const { name, itemIndex, presetSize } = input;

    const { spotShipmentPresetSizes, selectedUnitSystem } = this.props;

    /** Don't deselect if changed dimension is height and preset does not contain height definition */
    const segmentForPresets = this.getSegmentForPresets(itemIndex);
    const currentPreset = spotShipmentPresetSizes[segmentForPresets].find(
      (preset) =>
        preset.presetSize === presetSize || preset.value === presetSize
    );
    if (
      name === "height" &&
      !!currentPreset &&
      (!("height" in currentPreset[selectedUnitSystem]) ||
        currentPreset[selectedUnitSystem].height === "")
    ) {
      return false;
    }

    return true;
  };

  updateItem = (input, itemIndex, unitSystem) => {
    const { updateItem, items } = this.props;

    const { name, value } = input;

    const newItemValues = {
      [name]: value,
      unitSystem,
    };

    const generalizedName = removeIndexSuffix(name);
    if (
      this.isDimensionField(generalizedName) &&
      !!items[itemIndex].presetSize &&
      value !== items[itemIndex][generalizedName]
    ) {
      const valuesForPresetCheck = {
        name: generalizedName,
        itemIndex,
        presetSize: items[itemIndex].presetSize,
      };
      if (this.shouldPresetGetDeselected(valuesForPresetCheck)) {
        newItemValues.presetSize = "";
      }
    }

    updateItem({ itemIndex, newItemValues });
  };

  weightErrorClicked = (event) => {
    event.preventDefault();
    const { segmentReference, backToTradeLaneReference } = this.props;

    const segmentReferenceDOMObject = segmentReference.current;
    scrollToComponent(backToTradeLaneReference.current, {
      offset: -120,
      align: "top",
    });
    segmentReferenceDOMObject.focus();
  };

  updateAndValidateItem = (input, itemIndex, unitSystem) => {
    this.validateFormFields(input, itemIndex);
    this.updateItem(input, itemIndex, unitSystem);
  };

  resetPreset = (itemIndex) => {
    const { updateItem } = this.props;

    const newItemValues = {
      preset: "",
      presetSize: "",
      parcelCode: "",
    };
    updateItem({ itemIndex, newItemValues });
  };

  onPresetChange = (preset, itemIndex) => {
    const {
      updateItem,
      selectedUnitSystem,
      clearDimensionFieldsValidationErrors,
    } = this.props;
    let newItemValues = {
      preset: "",
      presetSize: "",
      parcelCode: "",
    };
    if (preset !== null) {
      newItemValues = {
        ...newItemValues,
        preset: preset.key,
        presetSize: preset.presetSize,
        parcelCode: preset.parcelCode,
      };
      const presetWidth = preset[selectedUnitSystem].width;
      const presetHeight = preset[selectedUnitSystem].height;
      const presetLength = preset[selectedUnitSystem].length;
      newItemValues = {
        ...newItemValues,
        width: presetWidth,
        height: presetHeight,
        length: presetLength,
      };
      clearDimensionFieldsValidationErrors(itemIndex);
    }
    updateItem({ itemIndex, newItemValues });
    // Trigger validation for mandatory package field
    const validationInput = {
      name: `preset-${itemIndex}`,
      value: newItemValues.preset,
      required: true,
      validationAttributes: {
        required: true,
      },
    };

    this.validateFormFields(validationInput, itemIndex);
  };

  onDocumentTypeChange = (event) => {
    const {
      updateDocument,
      trackEvent,
      isBusiness,
      changeCategory,
      resetItems,
    } = this.props;
    const segment = isBusiness ? SEGMENT_TYPES.business : SEGMENT_TYPES.private;
    const value = event.target.value === SHIPMENT_TYPES.Documents;

    this.clearPresetsForAllItems();
    resetItems();

    updateDocument({ value, segment });
    trackEvent({ documentsCheckboxChecked: value });
    this.disableOtherCheckbox("documents", value);
    changeCategory(null);
    this.setState({
      shipmentType: event.target.value,
      dangerousGoodsCheckboxDisabled: value,
    });
  };

  onCheckboxChange = (event) => {
    const { onCheckboxChange } = this.props;

    const { name, checked } = event.target;

    onCheckboxChange(name, checked);
    this.disableOtherCheckbox(name, checked);
  };

  onQuantityChange = (itemIndex, unitSystem, input) => {
    const { updateItem } = this.props;
    const { value } = input;

    const newItemValues = { quantity: value };

    updateItem({ itemIndex, newItemValues, unitSystem });
    this.validateFormFields(input, itemIndex);
  };

  addShipmentLaneItem = (event) => {
    const { addShipmentLaneItem, trackEvent, items, isBusiness } = this.props;

    event.preventDefault();

    trackEvent({ [this.addShipmentLaneItemClickedTrackEventKey]: true });

    trackContentInteraction({
      name: UTF_EVENT_CONTENT_NAMES.ADD_ITEM,
      type: UTF_EVENT_TYPES.BUTTON,
      interaction: UTF_EVENT_INTERACTIONS.CLICK,
      position: UTF_EVENT_CONTENT_POSITION.SHIPMENT_LANE,
      context: isBusiness ? SEGMENT_TYPES.business : SEGMENT_TYPES.private,
    });

    const refToNextItem = this.shipmentLaneItemReferences[items.length];
    const refToFirstInput = this.shipmentLaneFirstInputReferences[items.length];

    addShipmentLaneItem();

    const timeOut = window.setTimeout(() => {
      if (refToNextItem.current && isScrollEnabled()) {
        scrollToComponent(refToNextItem.current, {
          offset: -100,
          align: "top",
        });
        if (refToFirstInput.current) {
          refToFirstInput.current.focus();
        }
      }
      window.clearTimeout(timeOut);
    }, 500);
  };

  removeShipmentLaneItemLocal = (itemClassName) => {
    const { trackEvent } = this.props;
    const deletedItem = document.getElementsByClassName(itemClassName)[0];
    deletedItem.classList.add("deleted-item");

    trackEvent({ [this.removeShipmentLaneItemClickedTrackEventKey]: true });
  };

  getCopy = (id, values, prefix = COPY_ID_PREFIX) => {
    const { intl } = this.props;
    if (
      this.experience &&
      this.experience !== "" &&
      !!intl.messages[`${prefix}.${id}_${this.experience}`]
    ) {
      return intl.formatMessage(
        { id: `${prefix}.${id}_${this.experience}` },
        values
      );
    }
    return intl.formatMessage({ id: `${prefix}.${id}` }, values);
  };

  render() {
    const {
      intl,
      items,
      isShipmentLaneVisibile,
      trackEvent,
      validity,
      isFormValid,
      prefillItemsValues,
      isBusiness,
      backToShipmentLaneReference,
      settingsDangerousGoods,
      configs,
      totalShipmentWeight,
      unitSystem,
      shipmentLaneCheckboxStatusWeightThreshold,
      selectedUnitSystem,
      isUnitSwitchEnabled,
      hasBackButtonClicked,
      abTestRunning,
      abTestVersion,
      spotShipmentPresetSizes,
      selectedCategory,
    } = this.props;

    const availableCategories = Array.from(
      new Set(
        spotShipmentPresetSizes[
          isBusiness ? SEGMENT_TYPES.business : SEGMENT_TYPES.private
        ].map((preset) => preset.category)
      )
    );
    const {
      isItemRemoved,
      dangerousGoodsCheckboxDisabled,
      shipmentType,
    } = this.state;

    const stepperEnabled =
      abTestRunning && abTestVersion === abTestVersions[STEPPER];

    const isCheckboxDisabledBecauseOfWeight =
      isBusiness &&
      totalShipmentWeight <
        shipmentLaneCheckboxStatusWeightThreshold[selectedUnitSystem];

    const nextItemIndex = items.length;
    this.shipmentLaneItemReferences[nextItemIndex] = React.createRef();
    this.shipmentLaneFirstInputReferences[nextItemIndex] = React.createRef();

    const isShipmentTypeSelected = shipmentType !== null;
    const isCategorySelected =
      shipmentType !== null && selectedCategory !== null;
    const isUnitSwitchVisible = isCategorySelected && isUnitSwitchEnabled;

    const dangerousGoodsTooltipContent = (
      <React.Fragment>
        <ToolTipText size={Sizes.XS} weight={700} isParagraph>
          {this.getCopy("settingsTooltipHeader")}
        </ToolTipText>
        <ToolTipText size={Sizes.XS}>
          {this.getCopy("dangerousGoodsTooltipText")}
        </ToolTipText>
      </React.Fragment>
    );
    return (
      <ErrorBoundary>
        {!!isShipmentLaneVisibile && (
          <ShipmentLaneFormWrapper
            stepperEnabled={stepperEnabled}
            step={2}
            copyNamespace={SS}
            className="grid-fluid no-padding"
            formReference={this.formReference}
            validateDomElement={(input) => this.validateFormFields(input)}
            onSubmit={this.onSubmit}
            buttonLabel={this.getCopy("submit")}
            buttonDataTrackingKey={this.getOffersTrackingKeyPath}
            trackEvent={trackEvent}
            trackEventKey="getOffersClicked"
            isFormValid={isFormValid}
            useMyOwnSubmitButton
            autoScrollToFirstValidationError
            ref={backToShipmentLaneReference}
            dataTestid="shipment-lane-form"
          >
            <span className="visually-hidden" aria-live="assertive">
              {this.getCopy("screenReaderLabel_messageOnAppear")}
            </span>
            {isItemRemoved && (
              <span className="visually-hidden" aria-live="assertive">
                {this.getCopy("screenReaderLabel_messageOnRemoveItem", {
                  totalItems: validity.items.length,
                })}
              </span>
            )}
            <PackageTypeSelector
              value={shipmentType}
              onChange={this.onDocumentTypeChange}
            />
            {isShipmentTypeSelected &&
            isBusiness &&
            shipmentType !== SHIPMENT_TYPES.Documents ? (
              <PackageCategorySelector
                availableCategories={availableCategories}
                onChange={this.onCategoryChange}
                value={selectedCategory}
              />
            ) : null}
            {isUnitSwitchVisible ? (
              <UnitSelectorContainer
                unitSystem={unitSystem}
                selectedUnitSystem={selectedUnitSystem}
                trackEvent={trackEvent}
                stepperEnabled={stepperEnabled}
              />
            ) : null}

            {(shipmentType !== null &&
              (selectedCategory !== null || !isBusiness)) ||
            shipmentType === SHIPMENT_TYPES.Documents ? (
              <Fragment>
                <PackageItemList packageCategory={selectedCategory}>
                  {validity.items.map((currentItemObject, itemIndex) => {
                    const {
                      weight,
                      height,
                      length,
                      width,
                      presetSize,
                      preset,
                    } = items[itemIndex];

                    let weightValue = weight;
                    let heightValue = height;
                    let lengthValue = length;
                    let widthValue = width;
                    let presetSizeValue = presetSize;

                    const currentItemIndex = itemIndex + 1;
                    const itemDescriptionId = `add-item-description-${currentItemIndex}`;
                    const totalItemsAmount = validity.items.length;
                    const segmentForPresets = this.getSegmentForPresets(
                      itemIndex
                    );

                    if (prefillItemsValues[itemIndex]) {
                      const prefilledItem = prefillItemsValues[itemIndex];
                      weightValue = prefilledItem.weight;
                      heightValue = prefilledItem.height;
                      lengthValue = prefilledItem.length;
                      widthValue = prefilledItem.width;
                      presetSizeValue = presetSize;
                    }
                    return (
                      <ItemCardWrapper
                        key={currentItemObject.id}
                        id={itemIndex}
                        ref={this.shipmentLaneItemReferences[itemIndex]}
                        className={`item-index-${currentItemIndex} ${
                          currentItemIndex > 1 && "added-item"
                        }`}
                        dimension="biDimensional"
                        spanMobile="12"
                        columnStartMobile="1"
                        spanTablet="12"
                        columnStartTablet="1"
                        spanDesktop="10"
                        columnStart="2"
                      >
                        <ItemCardContent>
                          <StyledItemCardHeader
                            dataTestid={`dimensions-content-card-${currentItemIndex}`}
                          >
                            <ResponsiveRender
                              render={(isMobile) =>
                                !isMobile && (
                                  <div className="message">
                                    {this.getCopy("AsterixIsMandatory")}
                                  </div>
                                )
                              }
                            />
                            {configs.isAddItemEnabled && (
                              <div className="number">
                                <StyledItemIndexNumber
                                  size={Sizes.XL}
                                  weight={800}
                                  isParagraph
                                >
                                  {`#${currentItemIndex}`}
                                </StyledItemIndexNumber>
                                <span
                                  className="visually-hidden"
                                  id={itemDescriptionId}
                                >
                                  {this.getCopy(
                                    "screenReaderLabel_shipmentItemNumber",
                                    {
                                      totalItems: totalItemsAmount,
                                      itemNumber: currentItemIndex,
                                    }
                                  )}
                                </span>
                              </div>
                            )}
                            {currentItemIndex > 1 && (
                              <span
                                className="visually-hidden total"
                                aria-live="assertive"
                              >
                                {this.getCopy(
                                  "screenReaderLabel_shipmentItemNumber",
                                  {
                                    totalItems: totalItemsAmount,
                                    itemNumber: currentItemIndex,
                                  }
                                )}
                              </span>
                            )}
                            {itemIndex > 0 && (
                              <StyledCloseIcon
                                icon={closeIcon}
                                className="close"
                                isClickable
                                onClick={() =>
                                  this.removeShipmentLaneItemLocal(
                                    `item-index-${currentItemIndex}`
                                  )
                                }
                                size="small"
                                fillHoverColor="var(--dui-color-red-400)"
                                fillColor="var(--dui-color-red-500)"
                                label={this.getCopy("removeItemCta")}
                                useAs="standalone"
                                data-testid={`remove-shipment-item-button-${itemIndex}`}
                                tabIndex="0"
                                dataTracking={
                                  this
                                    .removeShipmentLaneItemClickedTrackingKeyPath
                                }
                                itemAdded={totalItemsAmount > 1}
                              />
                            )}
                          </StyledItemCardHeader>
                          <StyledItemParameters isBusiness={isBusiness}>
                            <this.weightSelectorWithCountry
                              intl={intl}
                              weightLabel={
                                isBusiness
                                  ? this.getCopy("weightHeadline")
                                  : this.getCopy("weightHeadlinePrivate")
                              }
                              weightName={`weight-${itemIndex}`}
                              weightValue={weightValue}
                              onWeightChange={(item, currentUnitSystem) =>
                                this.onWeightChange(
                                  item,
                                  itemIndex,
                                  currentUnitSystem
                                )
                              }
                              onBlur={(item, currentUnitSystem) =>
                                this.updateAndValidateItem(
                                  item,
                                  itemIndex,
                                  currentUnitSystem
                                )
                              }
                              feedback={currentItemObject.weight}
                              trackEvent={trackEvent}
                              unitSystem={unitSystem}
                              selectedUnitSystem={selectedUnitSystem}
                              onWeightfeedbackLinkClick={
                                this.weightErrorClicked
                              }
                              iNeedTheseProps={["weightValidationRules"]}
                              isBusiness={isBusiness}
                              itemIndex={itemIndex}
                              addItemDescriptionId={
                                configs.isAddItemEnabled && totalItemsAmount > 1
                                  ? itemDescriptionId
                                  : ""
                              }
                              reference={
                                this.shipmentLaneFirstInputReferences[itemIndex]
                              }
                            />
                            <this.dimensionSelectorWithCountry
                              category={selectedCategory}
                              onDimensionBlur={(item, currentUnitSystem) =>
                                this.updateAndValidateItem(
                                  item,
                                  itemIndex,
                                  currentUnitSystem
                                )
                              }
                              onDimensionChange={(item, currentUnitSystem) => {
                                if (selectedCategory !== CATEGORIES.Pallet) {
                                  this.resetPreset(itemIndex);
                                }
                                this.updateAndValidateItem(
                                  item,
                                  itemIndex,
                                  currentUnitSystem
                                );
                              }}
                              heightLabel={this.getCopy("height")}
                              widthLabel={this.getCopy("width")}
                              lengthLabel={this.getCopy("length")}
                              heightError={currentItemObject.height}
                              widthError={currentItemObject.width}
                              lengthError={currentItemObject.length}
                              quantityError={currentItemObject.quantity}
                              heightValue={heightValue}
                              widthValue={widthValue}
                              lengthValue={lengthValue}
                              intl={intl}
                              presetSize={presetSizeValue}
                              trackEvent={trackEvent}
                              isBusiness={isBusiness}
                              unitSystem={unitSystem}
                              selectedUnitSystem={selectedUnitSystem}
                              iNeedTheseProps={[
                                "spotShipmentPresetSizes",
                                "quantityValidationRules",
                                "lengthValidationRules",
                                "heightValidationRules",
                                "widthValidationRules",
                              ]}
                              weight={items[itemIndex].weight}
                              weightError={currentItemObject.weight}
                              quantity={
                                items[itemIndex].quantity === ""
                                  ? null
                                  : items[itemIndex].quantity
                              }
                              onQuantityChange={(currentUnitSystem, input) =>
                                this.onQuantityChange(
                                  itemIndex,
                                  currentUnitSystem,
                                  input
                                )
                              }
                              onQuantityBlur={(input) => {
                                this.validateFormFields(input);
                              }}
                              isQuantitySelectorEnabled={
                                configs.isQuantitySelectorEnabled
                              }
                              itemIndex={itemIndex}
                              addItemDescriptionId={
                                configs.isAddItemEnabled && totalItemsAmount > 1
                                  ? itemDescriptionId
                                  : ""
                              }
                              segmentForPresets={segmentForPresets}
                              isDocument={
                                shipmentType === SHIPMENT_TYPES.Documents
                              }
                            />
                          </StyledItemParameters>
                          <this.shipmentPresetSelectorWithCountry
                            selectedCategory={
                              selectedCategory ?? CATEGORIES.Parcel
                            }
                            onChange={(selectedPreset) => {
                              this.onPresetChange(selectedPreset, itemIndex);
                            }}
                            onBlur={(e) => {
                              const validationInput = {
                                name: `preset-${itemIndex}`,
                                value: e.target.value || preset,
                                required: true,
                                validationAttributes: {
                                  required: true,
                                },
                              };
                              this.validateFormFields(
                                validationInput,
                                itemIndex
                              );
                            }}
                            value={preset}
                            intl={intl}
                            spotShipmentPresetSizes={spotShipmentPresetSizes}
                            presetSegment={this.getSegmentForPresets(itemIndex)}
                            selectedUnitSystem={selectedUnitSystem}
                            nameSuffix={itemIndex}
                            validity={currentItemObject.preset}
                            iNeedTheseProps={[
                              "spotShipmentPresetSizes",
                              "unitSystem",
                            ]}
                          />
                          <ShipmentLaneAdvancedSettings
                            onCheckboxChange={(item, currentUnitSystem) =>
                              this.updateItem(
                                item,
                                itemIndex,
                                currentUnitSystem
                              )
                            }
                            settingsNonStackable={
                              items[itemIndex].settingsNonStackable
                            }
                            trackEvent={trackEvent}
                            itemIndex={itemIndex}
                            ariaDescribedBy={`advanced-settings-${itemIndex}`}
                            isCheckboxDisabledBecauseOfWeight={
                              isCheckboxDisabledBecauseOfWeight
                            }
                          />
                          {itemIndex > 0 && (
                            <StyledHiddenCloseIconContainer>
                              <StyledHiddenCloseIcon
                                icon={closeIcon}
                                isClickable
                                onClick={() =>
                                  this.removeShipmentLaneItemLocal(
                                    `item-index-${currentItemIndex}`
                                  )
                                }
                                size="small"
                                fillHoverColor="var(--dui-color-red-400)"
                                fillColor="var(--dui-color-red-500)"
                                label={this.getCopy("removeItem", {
                                  totalItems: totalItemsAmount,
                                  itemNumber: currentItemIndex,
                                })}
                                useAs="standalone"
                                data-testid="remove-shipment-item-button"
                                tabIndex="0"
                                dataTracking={
                                  this
                                    .removeShipmentLaneItemClickedTrackingKeyPath
                                }
                                itemAdded={totalItemsAmount > 1}
                              />
                            </StyledHiddenCloseIconContainer>
                          )}
                        </ItemCardContent>
                      </ItemCardWrapper>
                    );
                  })}
                </PackageItemList>
                <div className="mx-wrapper">
                  <ShipmentItemContainer>
                    <ShipmentItemContainerGroup>
                      {configs.isAddItemEnabled && (
                        <StyledIconButton
                          ariaLabel={this.getCopy(
                            "screenReaderLabel_addItemDescription"
                          )}
                          buttonStyle="outlineBlack"
                          icon={plusIcon}
                          type="button"
                          value="addItem"
                          name="addItem"
                          data-testid="add-shipment-item-button"
                          disabled={
                            validity.items.length >=
                            configs.maxNumberOfShipmentItems
                          }
                          onClick={this.addShipmentLaneItem}
                          dataTracking={
                            this.addShipmentLaneItemClickedTrackingKeyPath
                          }
                        >
                          {this.getCopy("addItem")}
                        </StyledIconButton>
                      )}
                      <StyledTotalShipmentWeightWrapper
                        addItemButtonVisible={configs.isAddItemEnabled}
                      >
                        <DhlText
                          size={Sizes.XL}
                          weight={700}
                          dataTestid="total-shipment-weight"
                          isParagraph
                        >
                          {this.getCopy("totalShipmentWeightLabel")}{" "}
                          {Number.isNaN(totalShipmentWeight)
                            ? "-"
                            : `${totalShipmentWeight} ${unitSystem[selectedUnitSystem].weight}`}
                        </DhlText>
                      </StyledTotalShipmentWeightWrapper>
                    </ShipmentItemContainerGroup>
                    <ShipmentItemContainerGroup className="stretch">
                      <SettingsCheckboxWrapper>
                        {configs.isDangerousGoodsEnabled &&
                          shipmentType === "non-documents" && (
                            <StyledCheckboxInfo>
                              <DhlCheckbox
                                dataId="dangerous-goods-checkbox"
                                dataTestid="dangerous-goods-checkbox"
                                name="settingsDangerousGoods"
                                size={Sizes.SM}
                                value="settingsDangerousGoods"
                                checked={settingsDangerousGoods}
                                onDhlChange={this.onCheckboxChange}
                                trackEvent={trackEvent}
                                dataTracking={
                                  this.dangerousGoodsCheckboxTrackingKeyPath
                                }
                                isDisabled={
                                  isCheckboxDisabledBecauseOfWeight ||
                                  dangerousGoodsCheckboxDisabled
                                }
                                label={this.getCopy("dangerousGoodsLabel")}
                              />
                              <IconButtonTooltip
                                id="tooltip-dangerous-goods"
                                dataTracking={
                                  this.dangerousGoodsCheckboxIconTrackingKeyPath
                                }
                                ariaLabel={this.getCopy("dangerousGoodsLabel")}
                                iconTrackEventKey={
                                  this.dangerousGoodsCheckboxIconTrackEventKey
                                }
                                name="icon-settingsDangerousGoods"
                                iconType="help"
                                trackEvent={trackEvent}
                                tooltipContent={dangerousGoodsTooltipContent}
                              />
                            </StyledCheckboxInfo>
                          )}
                      </SettingsCheckboxWrapper>
                      <SubmitButton
                        type="submit"
                        value="button"
                        name="submit"
                        isFullWidth={stepperEnabled}
                        stepperEnabled={stepperEnabled}
                        dataTestid="get-a-quote-button"
                        data-tracking={this.getOffersTrackingKeyPath}
                      >
                        {this.getCopy("submit_business")}{" "}
                      </SubmitButton>
                      <BackButtonCell
                        spanMobile="12"
                        columnStartMobile="1"
                        gridColumn="9 / span 2"
                      >
                        {stepperEnabled && (
                          <CustomBackButton
                            onClick={() => hasBackButtonClicked()}
                          >
                            <StyledIconWrapper>
                              <Icon useAs="decorative" icon={arrowBack} />
                            </StyledIconWrapper>
                            {this.getCopy(
                              "back",
                              undefined,
                              COPY_ID_PREFIX_NAVIGATION
                            )}
                          </CustomBackButton>
                        )}
                      </BackButtonCell>
                    </ShipmentItemContainerGroup>

                    <ResponsiveRender
                      render={(isMobile) =>
                        isMobile &&
                        stepperEnabled && (
                          <StepNoteCell>
                            {this.getCopy(
                              "next",
                              undefined,
                              COPY_ID_PREFIX_NAVIGATION
                            )}{" "}
                            :{" "}
                            {this.getCopy(
                              "bookNow",
                              undefined,
                              COPY_ID_PREFIX_STEPPER
                            )}
                          </StepNoteCell>
                        )
                      }
                    />
                  </ShipmentItemContainer>
                </div>
              </Fragment>
            ) : null}
          </ShipmentLaneFormWrapper>
        )}
      </ErrorBoundary>
    );
  }
}

export default injectIntl(FreightComponent);
